
define('app/board/models/chatMessageModel',[
	'jquery',
	'underscore',
	'backbone'
], function($, _, Backbone){
	var ChatMessageModel = Backbone.Model.extend({	
		defaults: {
			id: null, 
			userName: null,
			dispName: null,
			message: null
	    },

	    initialize: function() {
	    	
	    }
	});
	
	return ChatMessageModel;  
});